import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { FunctionComponent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { QuoteBlockData } from '../../../../../models';
import { InputField } from '../../../../InputField';
import { Select } from '../../../../Select';
import { TextAreaField } from '../../../../TextAreaField';
import { CloseWrapper, useBlockToolInputFocus } from '../../helpers';

import classes from './QuoteNodeView.module.scss';

export const QuoteNodeView: FunctionComponent<NodeViewProps> = ({
  editor,
  node,
  getPos,
  updateAttributes,
}) => {
  const { t } = useTranslation();

  const { onBlockInputFocus } = useBlockToolInputFocus({ editor, getPos });

  const { text, caption, alignment } = node.attrs as QuoteBlockData;

  const items = useMemo(
    () => [
      { id: 'left', title: t('richTextEditor.tools-quote-align-left') },
      { id: 'center', title: t('richTextEditor.tools-quote-align-center') },
    ],
    [t]
  );

  return (
    <NodeViewWrapper as={'div'}>
      <CloseWrapper editor={editor} node={node} getPos={getPos} className={classes['quote']}>
        <TextAreaField
          placeholder={t('richTextEditor.quote-config-text-placeholder')}
          value={text}
          onChange={({ target }) => updateAttributes({ text: target.value })}
          onFocus={onBlockInputFocus}
          minRows={2}
        />
        <InputField
          placeholder={t('richTextEditor.quote-config-author-placeholder')}
          value={caption}
          onChange={({ target }) => updateAttributes({ caption: target.value })}
          onFocus={onBlockInputFocus}
        />
        <Select
          selectedItemId={alignment}
          items={items}
          onChange={(alignment) => updateAttributes({ alignment })}
        />
      </CloseWrapper>
    </NodeViewWrapper>
  );
};
